export default __webpack_public_path__ + "static/media/flagSVG.761cabf7.svg";